export default __webpack_public_path__ + "static/Euclid Circular A Medium-a5befbfcb71cd093cc56db16973ca297.ttf";